module.exports = __webpack_public_path__ + "static/cardWhyImage-2523764f1dc6626ee58736a068c5f9e6.png";